<template lang="pug">
div
  v-card.round-xl(outlined :loading="isFetching")
    v-card-title.neutral200.px-3.py-2
      div.d-flex.align-center(style="width: 100%;")
        div.text-xs.neutral700--text {{ $options.filters.humanizeDatewithDay(todayDate) }}
        v-spacer
        y-button(label="Record new" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" height="24" button-class="px-2" @click="addVitalSign()")
    v-divider
    v-card-text.pa-0
      div.d-flex.align-center.justify-center.my-3(v-if="vitalSigns.length === 0")
        div.text-sm.neutral700--text No vital signs recorded.
        y-button.ml-3(label="Record vital signs" color="neutral300" prepend-icon="mdi-plus" icon-size="18" icon-color="neutral500" unset-min-width size="xxs" button-class="px-2" @click="addVitalSign()")
      template(v-else)
        //- type table
        v-simple-table.custom(dense)
          thead
            tr
              th.neutral500--text(style="text-transform: none !important;") Ht (cm)
              th.neutral500--text(style="text-transform: none !important;") Wt (kg)
              th.neutral500--text(style="text-transform: none !important;") Temp (C)
              th.neutral500--text(style="text-transform: none !important;") BP (mmHg)
              th.neutral500--text(style="text-transform: none !important;") HR/Pulse
              th.neutral500--text(style="text-transform: none !important;") SpO2
              th.neutral500--text(style="text-transform: none !important;") BG mmol/L
              th.neutral500--text(style="text-transform: none !important;") RR
              th.neutral500--text.text-end(style="text-transform: none !important;") Actions
          tbody
            tr(v-for="(vitalsign, idx) in vitalSigns" :key="`vts-${idx}`")
              td.text-sm.neutral700--text {{ vitalsign.height || '-' }}
              td.text-sm.neutral700--text {{ vitalsign.weight || '-' }}
              td.text-sm.neutral700--text {{ vitalsign.temperature ? `${vitalsign.temperature }°` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.bp_systolic ? `${vitalsign.bp_systolic}/${vitalsign.bp_diastolic}` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.pulse ? `${vitalsign.pulse } bpm` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.spo2 ? `${vitalsign.spo2 }%` : '-' }}
              td.text-sm.neutral700--text {{ vitalsign.blood_glucose || '-' }}
              td.text-sm.neutral700--text {{ vitalsign.respiratory_rate || '-' }}
              td.text-end
                //- y-button.mr-2(outlined color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-edit-02" icon-color="neutral700" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-1" @click="editVitalSign(vitalsign)")
                //- y-button(outlined color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-trash-03" icon-color="danger500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-1" @click="deleteVitalSign(vitalsign, idx)")
                v-btn(icon x-small color="transparent" @click="editVitalSign(vitalsign, idx)")
                  v-icon(color="neutral500" size="16") $yzi-edit-02
                v-btn.ml-3(icon x-small color="transparent" @click="deleteVitalSign(vitalsign, idx)")
                  v-icon(color="neutral500" size="18") $yzi-trash-03
  .dialogs
    delete-confirmation-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :loading="isFetching" @cancel="closeDeleteDialog" @delete="deleteSign")
      .text-lg.font-medium Are you sure you want to remove this vital record?
      .text-md.mt-4 This action will be done immediately and can’t be undone. Click “Confirm” to proceed
    y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width="1000" scrollable content-class="round-2xl")
      v-card
        v-card-title.px-4
          v-row(no-gutters)
            v-col(cols="10" offset="1")
              .text-xl.font-bold.text-center {{ sign.editing_index ? 'Edit vital' : 'Record vital' }}
            v-col(cols="1" align="right")
              v-btn(icon @click="closeDialog" small color="primary")
                v-icon mdi-close
        v-divider
        v-card-text.pa-6(outlined)
          v-row
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Date
              y-dialog(v-model='showPicker' width='380px' persistent content-class="round-3xl")
                template(v-slot:activator='{ on }')
                  v-text-field.text-sm.mt-2.round-xl(v-model="sign.field_date" placeholder="DD/MM/YYYY" outlined dense height="48" :rules="rules.not_empty" hide-details="auto" v-on="on" readonly)
                    template(v-slot:append)
                      eva-icon(name="calendar-outline" fill="#848484" style="margin-top: 2px;")
                v-card
                  v-card-text.px-2.pt-2.pb-0
                    yc-date-picker(:parentDate.sync="sign.date" color="info" @change="pickDate(sign)")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Time
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
          
          v-row
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Height
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.height" placeholder="0" outlined dense height="48" suffix="cm" type="number" hide-details="auto")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Weight
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.weight" placeholder="0" outlined dense height="48" suffix="kg" type="number" hide-details="auto")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Blood pressure
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.blood_pressure" placeholder="0/0" outlined dense height="48" :rules="sign.blood_pressure ? rules.valid_blood_pressure : []" suffix="mmHg" hide-details="auto")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Pulse
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.pulse" placeholder="0" outlined dense height="48" suffix="bpm" type="number" hide-details="auto")
          
          v-row
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Temperature
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.temperature" placeholder="0" outlined dense height="48" suffix="°C" type="number" hide-details="auto")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Blood glucose
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.blood_glucose" placeholder="0" outlined dense height="48" suffix="mmol/L" type="number" hide-details="auto")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text SpO2
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.spo2" placeholder="0" outlined dense height="48" suffix="%" type="number" hide-details="auto")
            v-col(cols="3")
              div.text-sm.font-semibold.neutral500--text Respiratory rate
              v-text-field.text-sm.mt-2.round-xl(v-model="sign.respiratory_rate" placeholder="0" outlined dense height="48" suffix="breath per min" type="number" hide-details="auto")

        v-divider
        v-card-actions.px-6.white
          v-spacer
          y-button(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
          y-button.ml-3(label="Save" size="sm" :loading="isLoading" @click="saveData")
              
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters, mapActions } from 'vuex'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'

export default {
  components: { DeleteConfirmationDialog },
  props: ['patient', 'vitalSigns', 'pid'],
  data () {
    return {
      isFetching: false,
      isLoading: false,
      showDialog: false,
      showDeleteDialog: false,
      showPicker: false,
      selectedRecord: null,
      sign: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_blood_pressure: [ v => /^\d+\/\d+$/.test(v) || 'Blood pressure must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    todayDate() {
      return new Date().toISOString();
    }
  },

  methods: {
    ...mapActions(['showMessage']),
    fetchVitalSigns () {
      this.isFetching = true
      let params = {
        page_size: -1,
        ordering: 'recorded_at'
      }
      this.$axios.get(`/clinics/${this.company.slug}/consultations/${this.pid}/vital_signs`, { params })
        .then(resp => {
          if (resp?.data?.results) {
            this.signs = resp.data.results.map(m => {
              const parsedDatetime  = DateTime.fromISO(m.recorded_at)
              const date = parsedDatetime.toFormat('yyyy-MM-dd')
              const time = parsedDatetime.toFormat('HH:mm')
              const field_date = this.$options.filters.displayDate(date)
              let blood_pressure = null
              if (m.bp_systolic && m.bp_diastolic) {
                blood_pressure = `${m.bp_systolic}/${m.bp_diastolic}`
              }
              return { ...m, date, time, field_date, blood_pressure, editable: false }
            })
            let data = resp.data.results
            this.$emit('update:vitalSigns', data)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    addVitalSign () {
      this.setData()
      this.showDialog = true
    },
    editVitalSign (vitalsign, idx) {
      this.setData(vitalsign, idx)
      this.showDialog = true
    },
    deleteVitalSign (vitalsign, idx) {
      if (vitalsign.id) {
        this.openDeleteDialog(vitalsign)
        return
      }
      let vitalsigns = JSON.parse(JSON.stringify(this.vitalSigns))
      vitalsigns.splice(idx, 1)
      this.$emit('update:vitalSigns', vitalsigns)
    },
    openDeleteDialog (sign) {
      this.selectedRecord = sign
      this.showDeleteDialog = true
    },
    closeDeleteDialog () {
      this.selectedRecord = null
      this.showDeleteDialog = false
    },
    deleteSign () {
      this.isFetching = true
      let sign = this.selectedRecord
      this.$axios.delete(`/clinics/${this.company.slug}/consultations/${this.pid}/vital_signs/${sign.id}`)
        .then(() => {
          this.fetchVitalSigns()
        })
        .catch(err => {
          this.isFetching = false
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.isFetching = false
        })
        .finally(() => {
          this.closeDeleteDialog()
        })
    },
    setData (vitalsign, idx) {
      if (vitalsign) {
        const parsedDatetime  = DateTime.fromISO(vitalsign.recorded_at)
        const date = vitalsign.date || parsedDatetime.toFormat('yyyy-MM-dd')
        const time = vitalsign.time || parsedDatetime.toFormat('HH:mm')
        const field_date = vitalsign.field_date || this.$options.filters.displayDate(date)
        let blood_pressure = null
        if (vitalsign.bp_systolic && vitalsign.bp_diastolic) {
          blood_pressure = `${vitalsign.bp_systolic}/${vitalsign.bp_diastolic}`
        }
        this.sign = { ...vitalsign, date, time, field_date, blood_pressure, editing_index: idx }
      } else {
        this.updateCurrentDateTime()
      }
    },
    pickDate (sign) {
      sign.field_date = this.$options.filters.displayDate(sign.date)
      this.showPicker = false
    },
    updateCurrentDateTime () {
      const now = DateTime.local()
      let date = now.toFormat('yyyy-MM-dd')
      let time = now.toFormat('HH:mm')
      this.$set(this.sign, 'field_date', this.$options.filters.displayDate(date))
      this.$set(this.sign, 'date', date)
      this.$set(this.sign, 'time', time)
    },
    saveData () {
      let data = { ...this.sign }
      data.recorded_at = `${this.sign.date} ${this.sign.time}`
      if (this.sign.blood_pressure) {
        data.bp_systolic = this.sign.blood_pressure.split('/')[0]
        data.bp_diastolic = this.sign.blood_pressure.split('/')[1]
      } else {
        data.bp_systolic = null
        data.bp_diastolic = null
      }
      data = this.sanitizeEmpty(data)
      let vitalsigns = JSON.parse(JSON.stringify(this.vitalSigns))
      if (this.sign.editing_index !== undefined && this.sign.editing_index !== null) {
        vitalsigns[this.sign.editing_index] = data
      } else {
        vitalsigns.push(data)
      }
      this.$emit('update:vitalSigns', vitalsigns)
      this.closeDialog()
    },
    sanitizeEmpty(data) {
      Object.keys(data).forEach(key => {
        if (data[key] === '' || data[key] === undefined || data[key] === null) {
          data[key] = null
        }
      })
      return data
    },
    closeDialog () {
      this.sign = {}
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .custom.v-data-table {
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    .v-data-table__wrapper table thead tr:last-child th {
      border-bottom: none;
    }
  }
}
</style>